import Image from 'next/image';
import Price from '@/components/price/Price';
import { SvgCheck } from '../Icons';

export function SingleCard({ card }) {
  return (
    <div className="mb-8 flex flex-col-reverse sm:flex-row">
      <div className="bg-parlor-green-95 content-center px-3 py-3 text-white sm:max-w-70 sm:px-4 sm:py-5">
        <div className="mb-3 sm:mb-4">
          <div className="h5 mb-1 sm:mb-3">{card.product.title}</div>
          {card?.description && (
            <div className="body-s">{card.description}</div>
          )}
        </div>
        <ul className="body-s mb-3 sm:mb-4">
          {card?.details?.length > 0 &&
            card?.details.map((detail, index) => {
              return (
                <li key={index} className="mb-2 flex">
                  <SvgCheck />
                  <div className="ml-1">{detail.text}</div>
                </li>
              );
            })}
        </ul>
        <Price
          price={card.variant.price.amount}
          compareAtPrice={card.variant.compareAtPrice.amount}
          priceClassOverride="price-l text-orange!"
          crossedPriceClassOverride="price-l-crossed text-dawn-grey-60!"
        />
      </div>
      <div>
        <Image
          src={card.image.url}
          alt={card.image.description}
          width={640}
          height={482}
          sizes="(min-width: 1024px) 715px, (min-width: 870px) 490px, (min-width: 640px) 640px, 640px"
          className="h-full object-cover"
        />
      </div>
    </div>
  );
}
